import * as React from 'react';

export interface IDtpStepDownloadProps {
    downloadUrl: string;
    onNextClick(): void;
}

export const DtpStepDownload = (props: IDtpStepDownloadProps) => {
    return (
        <div className={'dtp-portal-card'}>
            <div className="title">
                <span>Step: Download logo file</span>
            </div>
            <div className="content">
                <p>Original file upload by client: <a href={props.downloadUrl} download={true}>DOWNLOAD</a></p>
            </div>
            <div className="actions">
                <button className="action-continue" onClick={() => props.onNextClick()}>Continue</button>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-step-download.component.tsx